import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { NewProjectContext } from "../context/NewProjectContext";
import "../scss/order-form.scss";
import InputItem from "./InputItem";
import { validEmail, validNumber, validInput } from "../utils/formValidation";

const OrderForm = () => {
  const { handleOrder, order, need, pack } = useContext(NewProjectContext);
  const history = useHistory();

  const [project, setProject] = useState(
    order === null
      ? {
        title: "",
        deliveryDate: "",
        budget: "",
        description: "",
        lastName: "",
        firstName: "",
        email: "",
        tel: "",
      }
      : order
  );

  const [validValues, setValidValues] = useState({
    title: true,
    deliveryDate: true,
    budget: true,
    description: true,
    lastName: true,
    firstName: true,
    email: true,
    tel: true,
  });

  const [formValid, setFormValid] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setProject((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const validationOfValues = () => {
    const _validValues = {};

    for (const [key, value] of Object.entries(project)) {
      if (key === "email") {
        const valid = validEmail(value);
        _validValues[key] = valid;
      } else if (key === "tel") {
        const valid = validNumber(value);
        _validValues[key] = valid;
      } else {
        const valid = validInput(value);
        _validValues[key] = valid;
      }
    }

    setValidValues(_validValues);
    if (!Object.values(_validValues).includes(false)) {
      setFormValid(true);
    }
  };

  const handleClick = () => {
    handleOrder(project);
    validationOfValues();
  };

  useEffect(() => {
    if (pack === null) {
      history.push("/newproject/pack");
    }
  })
  useEffect(() => {
    if (formValid) {
      history.push("/newproject/resume");
    }
  }, [formValid, history]);

  return (
    <div className="main-wrapper">
      {/* Need & pack choose information */}
      <div className="order-information box">
        <h3>Récapitulatif de votre commande actuelle</h3>
        {need && pack &&
          <div>
            <p>Votre besoin &rarr; <span>{need}</span></p>
            <p>Voici le pack que vous avez choisi &rarr; {
              <Link to={`/prestations/${pack.id}-${pack.name}`}>
                <span>{pack.name}</span>
              </Link>
            }
            </p>
          </div>
        }
        <div>
          <p>Il ne vous reste plus qu'à renseigner vos informations !</p>
          <p>Nous serons ravi d'étudier votre devis et de vous donner une réponse.</p>
        </div>
      </div>
      <div className="form-order-wrapper box">
        <form className="form-order">
          <InputItem
            id="title"
            customStyle="input-form-title"
            description="Titre"
            placeHolder="Nom de votre projet"
            value={project.title}
            handleChange={handleChange}
            required="true"
            validation={validValues.title}
          />
          <InputItem
            id="deliveryDate"
            type="date"
            customStyle="input-form-date"
            description="Date de livraison"
            placeHolder="Quel date de livraison pour votre projet"
            value={project.deliveryDate}
            handleChange={handleChange}
            required="true"
            validation={validValues.deliveryDate}
          />
          <InputItem
            id="budget"
            customStyle="input-form-budget"
            description="Budget"
            placeHolder="Quel budget pour votre projet"
            value={project.budget}
            handleChange={handleChange}
            required="true"
            validation={validValues.budget}
          />
          <InputItem
            id="description"
            customStyle="input-form-description"
            description="Description du projet"
            placeHolder="Expliquez nous votre projet"
            item="text-area"
            value={project.description}
            handleChange={handleChange}
            required="true"
            validation={validValues.description}
          />
          <InputItem
            id="lastName"
            customStyle="input-form-lastname"
            description="Nom"
            placeHolder="Nom"
            value={project.lastName}
            handleChange={handleChange}
            required="true"
            validation={validValues.lastName}
          />
          <InputItem
            id="firstName"
            customStyle="input-form-firstname"
            description="Prénom"
            placeHolder="Prénom"
            value={project.firstName}
            handleChange={handleChange}
            required="true"
            validation={validValues.firstName}
          />
          <InputItem
            id="email"
            customStyle="input-form-email"
            description="Adresse E-Mail"
            placeHolder="Email"
            value={project.email}
            handleChange={handleChange}
            required="true"
            validation={validValues.email}
          />
          <InputItem
            id="tel"
            customStyle="input-form-tel"
            description="Téléphone"
            placeHolder="Téléphone"
            value={project.tel}
            handleChange={handleChange}
            required="true"
            validation={validValues.tel}
          />
        </form>
        <button className="btn-next validate-btn" onClick={handleClick}>
          Valider
        </button>
      </div>
    </div>

  );
};

export default OrderForm;
